<template>
  <router-view />
</template>

<style lang="scss">
@font-face {
  font-family: "Helvetica Neue";
  src: local("Helvetica Neue"),
    url(@/fonts/Helvetica-Neue-Viet-hoa/Helvetica-Neue-Viet-hoa/Helvetica/helveticaneue.ttf) format("truetype");
}
body {
  background-color: #f3f2f7 !important;
}
#app {
  font-family: "Helvetica Neue";
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;  
  color: #050B46;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #050B46;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
